import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { useApplicationCache } from '../../../queries/useApplicationCache';

/**
 * Reads the Construction Budget form for a given property from the React Query application cache.
 */
export function useBudgetConstructionCache(propertyGuid: string): IBudgetConstruction | undefined {
    return useApplicationCache(d =>
        d.information?.properties?.forms?.find(
            f => f.type === 'Budget' && f.propertyGuid === propertyGuid
        ) as IBudgetConstruction | undefined
    );
}
